export default "__VITE_ASSET__CHQOLvqV__"